import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagGBSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={props.size ?? 16} viewBox="0 0 16 16">
      <mask id="mask0_13700_23195" maskUnits="userSpaceOnUse" x="2" y="2" width="12" height="12">
        <rect x="2" y="2" width="12" height="12" rx="2" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_13700_23195)">
        <path
          d="M2 2.75C2 2.33579 2.33579 2 2.75 2H13.25C13.6642 2 14 2.33579 14 2.75V13.25C14 13.6642 13.6642 14 13.25 14H2.75C2.33579 14 2 13.6642 2 13.25V2.75Z"
          fill="#00247D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.54878 8L2 6.75L2.00009 3L8.00008 6.10325L14 3V6.75L11.4514 8L14 9.25V13L8.00008 9.89675L2.00009 13V9.25L4.54878 8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.21117 8L2.00003 7V4L8 7.04596L14 4V7L9.78886 8L14 9V12L8 8.95404L2.00003 12L2 9L6.21117 8Z"
          fill="#CF142B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.875 9.875V14H6.125V9.875H2V6.125H6.125V2H9.875V6.17221H14V9.875H9.875Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.875 6.875V2H9.125V6.875H14V9.125H9.125V14H6.875V9.125H2V6.875H6.875Z"
          fill="#CF142B"
        />
        <rect x="2.5" y="2.5" width="11" height="11" stroke="#3C3C60" strokeOpacity="0.1" />
      </g>
    </BaseIcon>
  );
}
